import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import PageTitle from '../../components/PageTitle';
import Main from '../../components/Main';
import DriStatementGeneration from '../DriStatementGeneration';
import DriStatementApproval from '../DriStatementApproval';
import DriInvoiceGeneration from '../DriInvoiceGeneration';
import DriCacheEviction from '../DriCacheEviction';
import DriTransactionRates from '../DriTransactionRates';
import DriDimensionListApproval from '../DriDimensionListApproval';
import DriStatistics from '../DriStatistics';
import DriContractDebug from '../DriContractDebug';
import DriManageEvents from '../DriManageEvents';
import DriDashboard from '../DriDashboard';
import { can } from '../../utils/auth';

const DriHome = () => {
  const { path } = useRouteMatch();
  return can('manageDRIOps') ? (
    <>
      <PageTitle>Operations</PageTitle>

      <Main>
        <Switch>
          <Route exact path={`${path}/dashboard`} component={DriDashboard} />
          <Route exact path={`${path}/contractDebug`} component={DriContractDebug} />
          <Route exact path={`${path}/cacheEviction`} component={DriCacheEviction} />
          <Route exact path={`${path}/statementGeneration`} component={DriStatementGeneration} />
          <Route exact path={`${path}/statementApproval`} component={DriStatementApproval} />
          <Route exact path={`${path}/invoiceGeneration`} component={DriInvoiceGeneration} />
          <Route exact path={`${path}/transactionRates`} component={DriTransactionRates} />
          <Route
            exact
            path={`${path}/dimensionListApproval`}
            component={DriDimensionListApproval}
          />
          <Route exact path={`${path}/statistics`} component={DriStatistics} />
          <Route exact path={`${path}/manage-events`} component={DriManageEvents} />
        </Switch>
      </Main>
    </>
  ) : (
    <>
      <PageTitle>Operations</PageTitle>

      <Main>
        <Switch>
          <Route exact path={`${path}/dashboard`} component={DriDashboard} />
          <Route exact path={`${path}/statementGeneration`} component={DriStatementGeneration} />
          <Route exact path={`${path}/statementApproval`} component={DriStatementApproval} />
          <Route exact path={`${path}/invoiceGeneration`} component={DriInvoiceGeneration} />
        </Switch>
      </Main>
    </>
  );
};

export default DriHome;
